import { ContractEntityAffiliationModel, ContractEntityDetailModel, ContractEntityHeaderInfo, ContractEntityScores, TinInformationModel } from "@app/projects/servicing-provider/providerAffiliation";
import { EntityTypeEnum } from "./enumerators";
import ServiceBase from "@app/shared/serviceBase";
import { querystringify } from "@app/shared/utility/querystringify";
import { SpecialtyCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";

export default class ProviderAffiliationService extends ServiceBase {

  public GetLatestContractEntitiesByNpi1(practitionerNpi: string, returnGhostPractitioners: boolean = true): Promise<ContractEntityAffiliationModel[]> {
    const data = this.makeGet<[]>(`/ProviderAffiliation/GetLatestContractEntitiesByNpi1?practitionerNpi1=${practitionerNpi}&returnGhostPractitioners=${returnGhostPractitioners}`);
    return data;
  }

  public async getContractEntityHeaderFieldsById(providerAffiliationVersionId: number, contractEntityId: number): Promise<ContractEntityHeaderInfo> {
    const query = { contractEntityId, providerAffiliationVersionId};
    const data = this.makeGet<ContractEntityHeaderInfo>(`ProviderAffiliation/GetContractEntityHeaderFieldsById?${querystringify(query)}`);
    return data;
  }

  public async getContractEntityContactNumberById(providerAffiliationVersionId: number, contractEntityId: number): Promise<string> {
    const query = { contractEntityId, providerAffiliationVersionId };
    const data = this.makeGet<string>(`ProviderAffiliation/GetContractEntityContactNumberById?${querystringify(query)}`);
    return data;
  }

  public GetContractEntityDetailsById(contractEntityId: number, versionId: number): Promise<ContractEntityDetailModel> {
    const data = this.makeGet<ContractEntityDetailModel>(`/ProviderAffiliation/GetContractEntityDetail?contractEntityId=${contractEntityId}&versionId=${versionId}`);
    return data;
  }

  public GetContractEntityScores(contractEntityId: number, versionId: number, projectId: number, projectRunConfigurationId: number): Promise<ContractEntityScores> {
    const data = this.makeGet<ContractEntityScores>(`/ProviderAffiliation/GetContractEntityScores?contractEntityId=${contractEntityId}&versionId=${versionId}&projectId=${projectId}&projectRunConfigurationId=${projectRunConfigurationId}`);
    return data;
  }

  public GetHDAContractEntityScores(contractEntityId: number, versionId: number): Promise<ContractEntityScores> {
    const data = this.makeGet<ContractEntityScores>(`/ProviderAffiliation/GetHDAContractEntityScores?contractEntityId=${contractEntityId}&versionId=${versionId}`);
    return data;
  }

  public getTinInformation(contractEntityId: number, versionId: number): Promise<TinInformationModel[]> {
    const data = this.makeGet<TinInformationModel[]>(`/ProviderAffiliation/GetContractEntityTinInformation?providerAffiliationVersionId=${versionId}&contractEntityId=${contractEntityId}`);
    return data;
    }

  public GetActiveProviderAffiliationVersion(signal?: AbortSignal): Promise<number> {
    return this.makeGet<number>("/ProviderAffiliation/ActiveProviderAffiliationVersion", null, undefined, false, undefined, signal);
    }

  public GetNPPESEntityTypeByNPI(npi: string, signal?: AbortSignal): Promise<EntityTypeEnum> {
    const data = this.makeGet<EntityTypeEnum>(`/Nppes/GetNPPESEntityTypeByNPI?npi=${npi}`, null, undefined, false, undefined, signal);
    return data;
  }

  public GetSpecialtiesByContractEntityId(contractEntityId: number, projectId: number, projectRunConfigurationId: number): Promise<SpecialtyCountModel[]> {
    const data = this.makeGet<SpecialtyCountModel[]>(`/ProviderAffiliation/GetSpecialtiesByContractEntityId?contractEntityId=${contractEntityId}&projectId=${projectId}&projectRunConfigurationId=${projectRunConfigurationId}`);
    return data;
  }
}